// extracted by mini-css-extract-plugin
export default {"loadingContainer1":"Dot_loadingContainer1__u2MyH","dot1":"Dot_dot1__L2H91","grow":"Dot_grow__-WmQ0","dot2":"Dot_dot2__KEuha","dot3":"Dot_dot3__kGoys","dot4":"Dot_dot4__Juaz8"};